import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/useAuth'
import { PrivacyPolicyFooter } from './components/PrivacyPolicyFooter/PrivacyPolicyFooter'
import styles from './PersonalInfo.module.scss'
import { useGetUserPrimaryUnit } from './useGetUserPrimaryUnit'
import { Widget } from '../Widget/Widget'

export const PersonalInfo = () => {
  const { user } = useAuth()
  const { t } = useTranslation()

  const primaryUnit = useGetUserPrimaryUnit()

  return (
    <div>
      <div className={styles.personalInfoContainer}>
        <Widget label={t('userProfile.email')} value={user?.email ?? 'N/A'} />
        <Widget label={t('userProfile.unit')} value={primaryUnit?.name ?? 'N/A'} />
      </div>

      <PrivacyPolicyFooter />
    </div>
  )
}
